import { Modal } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useRef, useState } from "react";

import ModalFooter from "components/Modal/modalFooter";
import { DeleteIcon, EditIcon, FileUploadIcon } from "themes/Icon";
import ButtonComp from "../Button";
import ModalComp from "../Modal"; // Ensure you import ModalComp
import "./file_upload.scss";

function FileUpload({
  defaultFileList = null,
  title = "Upload image or thumbnail",
  onChange = () => {},
  setPreviewImage,
  handleImageUpdate = () => {},
  previewImage,
  type,
  deleteModalOpen = false,
}) {
  const [fileList, setFileList] = useState(defaultFileList || []);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const fileInputRef = useRef(null);

  const onChangeHandler = (info) => {
    let newFileList = [...info.fileList];
    newFileList = newFileList.slice(-1); // Retain only the latest file

    updateFilePreview(newFileList[0]?.originFileObj);
    setFileList(newFileList);
    onChange(newFileList);
  };

  const updateFilePreview = (file) => {
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const preview = reader.result;
        setPreviewImage(preview);
        setPreviewUrl(preview);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      setPreviewUrl(null);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreviewImage();
      updateFilePreview(file);
      setFileList([
        {
          size: file.size,
          type: file.type,
          uid: file.uid || Date.now(),
          name: file.name,
          status: "done",
          originFileObj: file,
        },
      ]);
    }
  };

  const handleRemove = (file) => {
    if (deleteModalOpen) {
      setFileToDelete(file);
      setConfirmDeleteVisible(true);
    } else {
      directlyRemoveFile(file);
    }
  };

  const directlyRemoveFile = (file) => {
    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(newFileList);
    setPreviewImage(null);
    setPreviewUrl(null);
    // onChange(newFileList);
  };

  const confirmDelete = () => {
    const newFileList = fileList.filter(
      (item) => item.uid !== fileToDelete.uid
    );
    setFileList(newFileList);
    setPreviewImage(null);
    setPreviewUrl(null);
    onChange(newFileList);
    handleImageUpdate(-1, type, fileToDelete);
    setConfirmDeleteVisible(false);
  };

  const closeDeleteModal = () => {
    setConfirmDeleteVisible(false);
  };

  return (
    <div className="file-upload-container">
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".jpg,.jpeg,.png"
        onChange={handleFileChange}
      />
      {fileList.length === 0 ? (
        <Dragger
          name="file"
          accept=".jpg,.png,.jpeg"
          action={"http://localhost:3000/"}
          fileList={fileList}
          onChange={onChangeHandler}
          className="file-upload"
          showUploadList={false}
        >
          <span className="file-icon">
            <FileUploadIcon />
          </span>
          <h6 className="upload-text">{title}</h6>
          <ButtonComp height={33} className="mt-2" variant="secondary">
            Choose file
          </ButtonComp>
        </Dragger>
      ) : (
        <>
          {fileList.map((file) => (
            <div key={file.uid} className="file-container">
              <img
                src={file.url || previewUrl}
                alt="Preview"
                style={{ width: 50, height: 50, marginRight: 10 }}
                onClick={() => setPreviewVisible(true)}
              />
              <span className="file-icon">
                <FileUploadIcon />
              </span>
              <span className="upload-text file-name">{file.name}</span>
              <span className="edit-icon" onClick={triggerFileInput}>
                <EditIcon />
              </span>
              <span className="dlt-icon" onClick={() => handleRemove(file)}>
                <DeleteIcon />
              </span>
            </div>
          ))}
          <ModalComp
            open={confirmDeleteVisible}
            title="Confirm Deletion"
            setOpen={setConfirmDeleteVisible}
            OkClick={confirmDelete}
            CancelClick={closeDeleteModal}
            footer={
              <ModalFooter
                handlePrimaryBtn={() => setConfirmDeleteVisible(false)}
                primaryBtnVariant="secondary"
                primaryBtnText="Cancel"
                handleSecondaryBtn={confirmDelete}
                secondaryBtnvariant="danger"
                secondaryBtnText="Delete"
              />
            }
          >
            <p>
              Are you sure you want to delete this image? This action cannot be
              undone.
            </p>
          </ModalComp>
          <div className="preview-image">
            <Modal
              open={previewVisible}
              footer={null}
              onCancel={() => {
                setPreviewVisible(false);
              }}
              wrapClassName="preview-img-modal"
            >
              <img
                className="preview-img"
                src={previewUrl || previewImage}
                alt="Preview"
              />
            </Modal>
          </div>
        </>
      )}
    </div>
  );
}

export default FileUpload;
